import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './Notification.css';

export default toast;
